"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelTypes = exports.EngineTypes = exports.Stage = exports.Feature = exports.TaskStatus = void 0;
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["ACCEPTED"] = "ACCEPTED";
    TaskStatus["FINISHED"] = "FINISHED";
    TaskStatus["ABORTED"] = "ABORTED";
    TaskStatus["EXPIRED"] = "EXPIRED";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var Feature;
(function (Feature) {
    Feature["WLTP"] = "WLTP";
    Feature["NEFZ"] = "NEFZ";
    Feature["EEC"] = "EEC";
})(Feature = exports.Feature || (exports.Feature = {}));
var Stage;
(function (Stage) {
    Stage["DEV"] = "dev";
    Stage["TEST"] = "test";
    Stage["PROD"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
var EngineTypes;
(function (EngineTypes) {
    EngineTypes["COMBUSTION"] = "ICE";
    EngineTypes["ELECTRIC"] = "PEV";
    EngineTypes["MILDHYBRID"] = "NOVC_HEV";
    EngineTypes["PLUGINHYBRID"] = "OVC_HEV";
})(EngineTypes = exports.EngineTypes || (exports.EngineTypes = {}));
var FuelTypes;
(function (FuelTypes) {
    FuelTypes["PETROL"] = "PETROL";
    FuelTypes["DIESEL"] = "DIESEL";
    FuelTypes["CNG"] = "CNG";
    FuelTypes["ELECTRICAL"] = "ELECTRICAL";
})(FuelTypes = exports.FuelTypes || (exports.FuelTypes = {}));
